"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DappBlossomMessages = void 0;
const events_1 = require("../constants/events");
const window_util_1 = require("../utils/window.util");
const MESSAGE_TIMEOUT = 30000;
/**
 * Object that contains the resolve and reject functions of a promise
 */
class PromiseHandles {
    constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolveHandle, rejectHandle, onTimeout = null) {
        this.resolveHandle = resolveHandle;
        this.rejectHandle = rejectHandle;
        this.timeoutHandle = null;
        if (onTimeout) {
            this.timeoutHandle = setTimeout(() => {
                this.clearTimeout();
                onTimeout();
            }, MESSAGE_TIMEOUT);
        }
    }
    clearTimeout() {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }
    }
    resolve(data) {
        this.clearTimeout();
        this.resolveHandle(data);
    }
    reject(error) {
        this.clearTimeout();
        this.rejectHandle(error);
    }
}
class DappBlossomMessages {
    constructor() {
        this.pendingRequests = new Map();
        this.onReady = (0, window_util_1.getOnDocumentReadyPromise)();
        this.setListener();
    }
    sendMessage(action, parameters) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            if (!this.listener) {
                reject(new Error('Connection closed'));
                return;
            }
            const requestId = DappBlossomMessages.webRequestId++;
            this.pendingRequests.set(requestId, new PromiseHandles(resolve, reject, () => {
                this.completeRequest({
                    requestId,
                    data: null,
                    error: new Error('Request timeout'),
                });
            }));
            yield this.onReady;
            const event = new CustomEvent(events_1.BLOSSOM_API_EVENT, {
                detail: {
                    requestId,
                    action,
                    data: parameters,
                },
            });
            document.dispatchEvent(event);
        }));
    }
    closeConnection() {
        if (this.listener) {
            document.removeEventListener(events_1.BLOSSOM_API_RESPONSE_EVENT, this.listener);
            this.listener = undefined;
        }
    }
    setListener() {
        document.addEventListener(events_1.BLOSSOM_API_RESPONSE_EVENT, (this.listener = (event) => {
            const { detail } = event;
            if (!detail) {
                console.warn('Blossom: Received an invalid event from the extension');
                return;
            }
            this.completeRequest(detail);
        }));
    }
    completeRequest(response) {
        const { requestId, data, error } = response;
        if (!this.pendingRequests.has(requestId)) {
            return;
        }
        const promiseHandles = this.pendingRequests.get(requestId);
        this.pendingRequests.delete(requestId);
        if (error) {
            promiseHandles === null || promiseHandles === void 0 ? void 0 : promiseHandles.reject(error);
        }
        else {
            promiseHandles === null || promiseHandles === void 0 ? void 0 : promiseHandles.resolve(data);
        }
    }
}
exports.DappBlossomMessages = DappBlossomMessages;
DappBlossomMessages.webRequestId = 1;
